import React, { ReactNode } from 'react';
import { mergeClasses, tokens } from '@fluentui/react-components';

import { useCircularIconStyles } from './CircularIcon.styles';

interface CircularIconProps {
  icon: ReactNode
  backgroundColor?: string
  className?: string
};

const CircularIcon: React.FC<CircularIconProps> = ({ icon, backgroundColor = tokens.colorNeutralForeground3, className }: CircularIconProps) => {
  const styles = useCircularIconStyles();

  return (
    <div
      className={mergeClasses('circular-icon', styles.iconWrapper, className)}
      style={{ backgroundColor: backgroundColor }}
      data-testid="icon-container"
    >
      <div className={styles.iconCenter}>
        {icon}
      </div>
    </div>
  );
};

export default CircularIcon;
